import { IProject } from './../../models/IProject';
import { IBaseAction } from './../base';
import { IPromiseParam } from '../base';
import * as types from './actionTypes.gitHubIntegration';
import { IGetScriptsFromCiCdParam } from './saga.gitHubIntegration';
import { Environment } from '../../const/environment';

export interface IGetGitHubProjectSettingsParam extends IPromiseParam {
    projectId: string,
    testToken?: boolean,
    environment?: Environment,
}
export const getGitHubProjectSettings = ({ projectId, environment, resolve, reject }
    : IGetGitHubProjectSettingsParam)
    : IGetGitHubProjectSettingsParam & IBaseAction => ({
        type: types.GET_GITHUB_PROJECT_SETTINGS_REQ,
        projectId,
        environment,
        resolve,
        reject
    });

export interface IShowAddGithubRepoUrlPopupParam extends IPromiseParam {
    project: IProject,
    environment: Environment,
}
export const showAddGithubRepoUrlPopup = ({ project, environment }
    : IShowAddGithubRepoUrlPopupParam)
    : IShowAddGithubRepoUrlPopupParam & IBaseAction => ({
        type: types.SHOW_ADD_GITHUB_REPO_URL_POPUP,
        project,
        environment
    });

export interface IPullProjectFromGithubParam {
    project: IProject,
}
export const pullProjectFromGithub = ({ project }
    : IPullProjectFromGithubParam)
    : IPullProjectFromGithubParam & IBaseAction => ({
        type: types.PULL_PROJECT_FROM_GITHUB_REQ,
        project
    });

export interface IPushProjectToGithubParam {
    project: IProject,
    message: string,
}
export const pushProjectToGithub = ({ project, message }
    : IPushProjectToGithubParam)
    : IPushProjectToGithubParam & IBaseAction => ({
        type: types.PUSH_PROJECT_TO_GITHUB_REQ,
        project,
        message
    });

export interface IRemoveGitHubProjectSettingsParam {
    project: IProject,
}
export const removeGitHubProjectSettings = ({ project }
    : IRemoveGitHubProjectSettingsParam)
    : IRemoveGitHubProjectSettingsParam & IBaseAction => ({
        type: types.REMOVE_GITHUB_PROJECT_SETTINGS_REQ,
        project,
    });

export interface ICheckChangesToPullParam extends IPromiseParam {
    project: IProject,
}
export const checkChangesToPull = ({ project, resolve, reject }
    : ICheckChangesToPullParam)
    : ICheckChangesToPullParam & IBaseAction => ({
        type: types.CHECK_CHANGES_TO_PULL_FROM_GITHUB_REQ,
        project,
        resolve,
        reject
    });

export interface ICheckChangesToPushParam extends IPromiseParam {
    project: IProject,
    manually: boolean,
}
export const checkChangesToPush = ({ project, manually, resolve, reject }
    : ICheckChangesToPushParam)
    : ICheckChangesToPushParam & IBaseAction => ({
        type: types.CHECK_CHANGES_TO_PUSH_TO_GITHUB_REQ,
        project,
        manually,
        resolve,
        reject
    });

export interface ICheckProjectForUnsavedChangesParam extends IPromiseParam {
    project: IProject,
    gitAction: string,
}
export const checkProjectForUnsavedChanges = ({ project, gitAction, resolve, reject }
    : ICheckProjectForUnsavedChangesParam)
    : ICheckProjectForUnsavedChangesParam & IBaseAction => ({
        type: types.CHECK_FOR_UNSAVED_CHANGES_IN_PROJECT_FOR_GITHUB_REQ,
        project,
        gitAction,
        resolve,
        reject
    });

export const resetGitHubProjectData = () => ({
    type: types.RESET_GITHUB_PROJECT_DATA_REQ,
});

export const getRepositoriesByUser = () => ({
    type: types.GET_REPOSITORIES_BY_USER_REQ,
});

export interface IGetBranchesByRepositoryParam extends IPromiseParam {
    repo: string,
}
export const getBranchesByRepository = ({ repo, resolve, reject }
    : IGetBranchesByRepositoryParam)
    : IGetBranchesByRepositoryParam & IBaseAction => ({
        type: types.GET_BRANCHES_BY_REPOSITORY_REQ,
        repo,
        resolve,
        reject
    });

export interface IGetFilesByBranchParam extends IPromiseParam {
    repo: string,
    branch: string,
    commitSha: string,
    secondAttempt?: boolean,
}
export const getFilesByBranch = ({ repo, branch, commitSha, resolve, reject }
    : IGetFilesByBranchParam)
    : IGetFilesByBranchParam & IBaseAction => ({
        type: types.GET_FILES_BY_BRANCH_REQ,
        repo,
        branch,
        commitSha,
        resolve,
        reject
    });

export const resetBranchesAndFilesAfterSwithcingRepos = ()
    : IBaseAction => ({
        type: types.RESET_BRANCH_AND_FILES_AFTER_SWITCHING_REPO_REQ,
    });

export interface IAddRepoWithoutFilesToProjectParam extends IPromiseParam {
    project: IProject,
    repoUrl: string,
    branch: string,
    folder: string,
    repoPermissions: object
}
export const addRepoWithoutFilesToProject = ({ project, repoUrl, repoPermissions, branch, folder, resolve, reject }
    : IAddRepoWithoutFilesToProjectParam)
    : IAddRepoWithoutFilesToProjectParam & IBaseAction => ({
        type: types.ADD_REPO_WITHOUT_FILES_TO_PROJECT_REQ,
        project,
        repoUrl,
        branch,
        folder,
        repoPermissions,
        resolve,
        reject
    });

export interface IAddFilesToProjectParam extends IPromiseParam {
    project: IProject,
    repoUrl: string,
    branch: string,
    folder: string,
    files: any[],
    repoPermissions: object
}
export const addFilesToProject = ({ project, repoUrl, branch, folder, files, repoPermissions, resolve, reject }
    : IAddFilesToProjectParam)
    : IAddFilesToProjectParam & IBaseAction => ({
        type: types.ADD_FILES_TO_PROJECT_REQ,
        project,
        repoUrl,
        files,
        branch,
        folder,
        repoPermissions,
        resolve,
        reject
    });

export interface IAddRepoForCiCdParam extends IPromiseParam {
    project: IProject,
    repoUrl: string,
    branch: string,
    folder: string,
    environment: Environment,
}
export const addRepoForCiCd = ({ project, repoUrl, branch, folder, environment, resolve, reject }
    : IAddRepoForCiCdParam)
    : IAddRepoForCiCdParam & IBaseAction => ({
        type: types.ADD_REPO_FOR_CI_CD_REQ,
        project,
        repoUrl,
        branch,
        folder,
        environment,
        resolve,
        reject
    });

export const getScriptsForCiCd = ({ project, environment, resolve, reject }
    : IGetScriptsFromCiCdParam)
    : IGetScriptsFromCiCdParam & IBaseAction => ({
        type: types.GET_SCRIPTS_FOR_CI_CD_REQ,
        project,
        environment,
        resolve,
        reject
    });



export interface IPushTestCasesParam extends IPromiseParam {
    project: IProject,
}
export const pushTestCases = ({ project, resolve, reject }
    : IPushTestCasesParam)
    : IPushTestCasesParam & IBaseAction => ({
        type: types.PUSH_TEST_CASES_REQ,
        project,
        resolve,
        reject
    });


export const revokeGithubAccess = ()
    : IBaseAction => ({
        type: types.REVOKE_GITHUB_ACCESS_REQ
    });
